<template>
  <div class="bg-gray-200 flex items-center">
    <button v-for="tab in tabs"
            :key="tab.value"
            class="p-2 flex-1 leading-6"
            :class="{
              'bg-white text-blue-400': value === tab.value
            }"
            @click="onClick(tab)"
    >{{ tab.label }}</button>
  </div>
</template>

<script>
import {mapActions, mapMutations} from "vuex";

export default {
  name: 'GrmTabs',
  props: {
    value: { type: String, required: true },
    tabs: { type: Array, required: true },
  },
  methods: {
    ...mapMutations('testbank', [
      'SET_VIEW',
    ]),

    onClick(tab) {
      this.SET_VIEW(`${tab.value}__list`);
      this.$emit('update:value', tab.value);
    },
  }
}
</script>